import { render, staticRenderFns } from "./MypageTicketPastPane.vue?vue&type=template&id=d748ecec&scoped=true"
import script from "./MypageTicketPastPane.vue?vue&type=script&lang=ts"
export * from "./MypageTicketPastPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketPastPane.vue?vue&type=style&index=0&id=d748ecec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d748ecec",
  null
  
)

export default component.exports